export default __webpack_public_path__ + "static/media/bg2.2f318522.jpg";